import { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import withFormikField from './withFormikField';

class ChangesHandler extends Component {
  componentWillReceiveProps(nextProps) {
    const { form, onChange, blockChangesTrigger } = this.props;
    const { form: newForm } = nextProps;

    if (!onChange) {
      return;
    }

    const { values } = form;
    const { values: newValues } = newForm;

    if (!_.isEqual(values, newValues) || (!form.isValid && newForm.isValid)) {
      if (
        blockChangesTrigger({
          props: this.props,
          nextProps,
        })
      ) {
        return;
      }

      onChange(newForm);
      return;
    }
  }
  render() {
    return null;
  }
}

ChangesHandler.propTypes = {
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  blockChangesTrigger: PropTypes.func,
};

ChangesHandler.defaultProps = {
  onChange: () => {
    /*nop*/
  },
  blockChangesTrigger: () => false,
};

export default withFormikField(ChangesHandler);
